import { ApplicationRef, Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { SwUpdate } from '@angular/service-worker';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { CoreProvider } from './core';

@Injectable({ providedIn: 'root' })
export class VersionServiceProvider {

  private readyUpdateNoticed: boolean = false;
  private versionNumberData: string = '';
  private expireTimestampData: string = '1970-01-01 00:00:00';
  private core: CoreProvider;
  public get number(): string {
    return this.versionNumberData;
  }
  public get expireTimestamp(): string {
    return this.expireTimestampData;
  }
  public get versionExpired(): boolean {
    return (!this.core)
      ? false
      : (this.updateable && (new Date())>this.core.getDateFromTimestamp(this.expireTimestampData))
    ;
  }
  private updatePepared: boolean = false;
  public get updateable(): boolean {
    return this.updatePepared;
  }
  updateInterval;

  config = {
    updateIntervalDelay: 1 * 60 * 1000, // 1 minute
    autoUpdateOnInit: false,
    updateModal: null
  };

  constructor(
    private appVersion: AppVersion,
    private meta: Meta,
    private appRef: ApplicationRef,
    private swUpdate: SwUpdate
  ) {
    swUpdate.available.subscribe((e) => {
      this.core.console.debug('UPDATE AVAILABLE, updating... ', e);
      swUpdate.activateUpdate().then(() => {
        this.core.console.debug('UPDATE PREPARED: ', e);
        this.updatePepared = true;
        let d = new Date();
        d.setUTCDate(d.getUTCDate()+1);
        this.expireTimestampData = d.toISOString().slice(0, 19).replace('T', ' ').replace('Z', '');
        this.checkForUpdateModal();
      });
    });
  }

  public init(core: CoreProvider) {
    this.core = core;
    this.appVersion.getVersionNumber().then(
      (v) => {
        this.versionNumberData = v;
        this.checkForUpdates(true, () => this.checkForUpdateModal());
      },
      () => {
        // PWA
        const viewport = this.meta.getTag('name=version');
        this.versionNumberData = viewport.content;
        this.checkForUpdates(true, () => this.checkForUpdateModal());
      }
    );
  }

  public getVersion(): string {
    return this.versionNumberData;
  }

  private checkForUpdates(firstSync = false, cb = null) {
    if (!this.swUpdate.isEnabled) {
      console.warn('Prevented check for updates: swUpdate is disabled.');
      return;
    }
    this.swUpdate.checkForUpdate().then(() => {
      if (firstSync) {
        this.core.appIsStable.subscribe(() => this.startUpdateInterval());
        if (this.config.autoUpdateOnInit) this.update();
      }
      if (cb) cb();
    });

  }

  public startUpdateInterval() {
    this.appRef.isStable.subscribe(() => {
      if (this.config.updateIntervalDelay) {
        if (this.updateInterval) clearInterval(this.updateInterval);
        this.updateInterval = setInterval(() => {
          this.checkForUpdates(false, () => this.checkForUpdateModal());
        }, this.config.updateIntervalDelay);
      }
    });
  }

  private checkForUpdateModal() {
    if (this.config.updateModal) {
      if (!this.readyUpdateNoticed && this.updateable && !this.config.updateModal.oppened) {
        this.readyUpdateNoticed = true;
        this.config.updateModal.Open(this.core);
      } else if (this.versionExpired && !this.config.updateModal.oppened) {
        this.config.updateModal.Open(this.core);
      }
    }
  }

  public stopUpdateInterval() {
    clearInterval(this.updateInterval);
  }

  public update(force: boolean = false) {
    if (force || this.updateable) {
      this.runUpdate();
    } else {
      // TODO: Handle err
    }
  }

  private runUpdate() {
    location.reload();
    // caches.keys().then((keyList) => {
    //   return Promise.all(keyList.map((key) => {
    //     return caches.delete(key);
    //   }));
    // }).then(() => {
    //   location.reload();
    // });
  }

}
